export const lugaresTuristicos = [
  {
    id: 1,
    nombre: "Salar de Uyuni",
    descripcion: "El salar más grande del mundo, con más de 10,000 km² de superficie. Un paisaje surrealista de sal blanca que refleja el cielo como un espejo.",
    region: "Altiplano",
    coordenadas: [-20.1333, -67.3667],
    imagenes: [
      "https://www.turismo.produccion.gob.bo/wp-content/uploads/2021/03/WhatsApp-Image-2021-03-07-at-7.00.58-PM.jpeg",
      "https://abi.bo/images/2024/Julio/15/SALAR_1.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Mayo a Octubre",
      clima: "Seco y frío",
      precioEntrada: "150 Bs",
      comoLlegar: "Avión a Uyuni desde La Paz, o bus desde Potosí"
    },
    destacado: true
  },
  {
    id: 2,
    nombre: "Tiwanaku",
    descripcion: "Sitio arqueológico preincaico, centro ceremonial y político de una de las civilizaciones más importantes de América del Sur.",
    region: "Altiplano",
    coordenadas: [-16.5547, -68.6734],
    imagenes: [
      "https://images.unsplash.com/photo-1589308078059-be1415eab4c3?w=800",
      "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800"
    ],
    informacionPractica: {
      mejorEpoca: "Todo el año",
      clima: "Frío y seco",
      precioEntrada: "100 Bs",
      comoLlegar: "Bus desde La Paz (1 hora)"
    },
    destacado: true
  },
  {
    id: 3,
    nombre: "Lago Titicaca",
    descripcion: "El lago navegable más alto del mundo, compartido con Perú. Hogar de las Islas del Sol y la Luna.",
    region: "Altiplano",
    coordenadas: [-16.1667, -68.6833],
    imagenes: [
      "https://boliviaturistica.com/wp-content/uploads/2018/08/Lago-Titicaca-Bolivia.jpg",
      "https://miaventuraviajando.com/wp-content/uploads/2018/10/Lago-Titicaca-Mi-Aventura-Viajando-45.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Abril a Octubre",
      clima: "Frío y seco",
      precioEntrada: "Gratis",
      comoLlegar: "Bus desde La Paz a Copacabana"
    },
    destacado: false
  },
  {
    id: 4,
    nombre: "Sucre",
    descripcion: "La Ciudad Blanca, capital constitucional de Bolivia. Patrimonio de la Humanidad con arquitectura colonial.",
    region: "Valles",
    coordenadas: [-19.0473, -65.2596],
    imagenes: [
      "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0b/48/3a/d4/topo.jpg?w=1200&h=700&s=1",
      "https://www.lavanguardia.com/files/og_thumbnail/uploads/2020/03/03/5fa8ff6134bb8.jpeg"
    ],
    informacionPractica: {
      mejorEpoca: "Todo el año",
      clima: "Templado",
      precioEntrada: "Gratis",
      comoLlegar: "Avión desde La Paz o bus (12 horas)"
    },
    destacado: true
  },
  {
    id: 5,
    nombre: "Potosí",
    descripcion: "Ciudad histórica conocida por sus minas de plata. Patrimonio de la Humanidad con rica historia colonial.",
    region: "Valles",
    coordenadas: [-19.5833, -65.7500],
    imagenes: [
      "https://i0.wp.com/unaguiaenmimaleta.com/wp-content/uploads/2024/08/Que-ver-en-Bolivia-222.jpg?resize=770%2C514&ssl=1",
      "https://uploads.exoticca.com/global/destination/poi/salar-uyuni.png",
      "https://www.dosmanosperu.com/fotos/contenidos/zoom/potosi-santa-teresa-museum.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Abril a Octubre",
      clima: "Frío y seco",
      precioEntrada: "Gratis",
      comoLlegar: "Bus desde Sucre (3 horas)"
    },
    destacado: false
  },
  {
    id: 6,
    nombre: "Santa Cruz",
    descripcion: "La ciudad más grande de Bolivia, centro económico y comercial. Clima tropical y cultura oriental.",
    region: "Llanos",
    coordenadas: [-17.7833, -63.1833],
    imagenes: [
      "https://www.laregion.bo/wp-content/uploads/2015/11/PARQUE-NOEL-KEMPF-1024x681.jpg",
      "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800"
    ],
    informacionPractica: {
      mejorEpoca: "Mayo a Octubre",
      clima: "Tropical",
      precioEntrada: "Gratis",
      comoLlegar: "Avión desde La Paz o bus (18 horas)"
    },
    destacado: false
  },
  {
    id: 7,
    nombre: "Rurrenabaque",
    descripcion: "Puerta de entrada a la Amazonía boliviana. Base para visitar el Parque Nacional Madidi.",
    region: "Amazonía",
    coordenadas: [-14.4333, -67.5500],
    imagenes: [
      "https://boliviatravelsite.com/Images/Rurrenabaque/rurrenabaque.jpg",
      "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0d/80/4c/1b/rio-beni.jpg?w=1400&h=1400&s=1"
    ],
    informacionPractica: {
      mejorEpoca: "Mayo a Octubre",
      clima: "Tropical húmedo",
      precioEntrada: "Gratis",
      comoLlegar: "Avión desde La Paz o bus (20 horas)"
    },
    destacado: false
  },
  {
    id: 8,
    nombre: "Tarija",
    descripcion: "Conocida como la Andalucía de Bolivia. Famosa por sus vinos y clima mediterráneo.",
    region: "Valles",
    coordenadas: [-21.5333, -64.7333],
    imagenes: [
      "https://cdn.bolivia.com/sdi/2022/10/13/atractivos-turisticos-de-tarija-bolivia-1074687.jpg",
      "https://explorandomaravillas.com/wp-content/uploads/cascadas-de-coimata.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Todo el año",
      clima: "Templado mediterráneo",
      precioEntrada: "Gratis",
      comoLlegar: "Avión desde La Paz o bus (16 horas)"
    },
    destacado: false
  },

  // NUEVOS LUGARES EN OTRAS REGIONES
  {
    id: 9,
    nombre: "Parque Nacional Madidi",
    descripcion: "Selva amazónica con alta biodiversidad. Ideal para ecoturismo y observación de fauna.",
    region: "Amazonía",
    coordenadas: [-14.6, -67.75],
    imagenes: [
      "https://www.andeantrails.co.uk/nitropack_static/iwfVQrUWbgdNPzhPfPdurFCwDZQSldCZ/assets/images/optimized/rev-38b0105/www.andeantrails.co.uk/wp-content/uploads/2018/03/Heath-River-giant-otter-Peru-1024x683.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Mayo a Septiembre",
      clima: "Tropical húmedo",
      precioEntrada: "50 Bs",
      comoLlegar: "Desde Rurrenabaque en lancha o avión"
    },
    destacado: true
  },
  {
    id: 10,
    nombre: "Samaña",
    descripcion: "Pequeño pueblo tradicional en los valles, conocido por sus paisajes y gastronomía.",
    region: "Valles",
    coordenadas: [-18.3, -64.5],
    imagenes: [
      "https://weepingredorger.wordpress.com/wp-content/uploads/2017/04/img_5415-5.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Todo el año",
      clima: "Templado",
      precioEntrada: "Gratis",
      comoLlegar: "Bus desde Tarija"
    },
    destacado: false
  },
  {
    id: 11,
    nombre: "Chiquitania",
    descripcion: "Región de bosques secos y misiones jesuíticas coloniales.",
    region: "Llanos",
    coordenadas: [-18.0, -62.8],
    imagenes: [
      "https://trayectoriasenviaje.com/wp-content/uploads/2017/01/chiquitania_02.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Mayo a Octubre",
      clima: "Semi-tropical",
      precioEntrada: "Gratis",
      comoLlegar: "Avión o bus desde Santa Cruz"
    },
    destacado: true
  },
  {
    id: 12,
    nombre: "Sajama",
    descripcion: "Parque nacional con el nevado Sajama y termas naturales.",
    region: "Altiplano",
    coordenadas: [-18.1, -68.9],
    imagenes: [
      "https://ahoraelpueblo.bo/images/2025/Noticias/Regional/02/SAJAMA_100225.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Mayo a Septiembre",
      clima: "Frío y seco",
      precioEntrada: "Gratis",
      comoLlegar: "Desde Oruro en bus"
    },
    destacado: false
  },
  {
    id: 13,
    nombre: "Isla del Sol",
    descripcion: "Isla en el Lago Titicaca con ruinas incaicas y senderos turísticos.",
    region: "Altiplano",
    coordenadas: [-16.1, -69.0],
    imagenes: [
      "https://amuraworld.com/images/articles/038-tahiti/076-ventanas/076-isla-sol.png"
    ],
    informacionPractica: {
      mejorEpoca: "Abril a Octubre",
      clima: "Frío y seco",
      precioEntrada: "Gratis",
      comoLlegar: "Desde Copacabana en lancha"
    },
    destacado: true
  },
  {
    id: 14,
    nombre: "Coroico",
    descripcion: "Pueblo turístico en los Yungas con carretera de la muerte cercana.",
    region: "Yungas",
    coordenadas: [-16.15, -67.73],
    imagenes: [
      "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/16/eb/0d/1b/lo-especial-de-sol-y.jpg?w=1200&h=1200&s=1"
    ],
    informacionPractica: {
      mejorEpoca: "Todo el año",
      clima: "Tropical húmedo",
      precioEntrada: "Gratis",
      comoLlegar: "Bus desde La Paz"
    },
    destacado: false
  },
  {
    id: 15,
    nombre: "San José de Chiquitos",
    descripcion: "Pueblo histórico con misiones jesuíticas y arquitectura colonial.",
    region: "Llanos",
    coordenadas: [-18.8, -59.8],
    imagenes: [
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRCK2nwYd9ezuOWve4ixHdEgvyxOe52bOSbRw&s"
    ],
    informacionPractica: {
      mejorEpoca: "Mayo a Octubre",
      clima: "Semi-tropical",
      precioEntrada: "Gratis",
      comoLlegar: "Bus desde Santa Cruz"
    },
    destacado: false
  },
  {
    id: 16,
    nombre: "Rurrenabaque Canopy",
    descripcion: "Turismo de aventura con canopy y excursiones en la Amazonía.",
    region: "Amazonía",
    coordenadas: [-14.42, -67.55],
    imagenes: [
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSAfbjAmsJ2iBFeGRaboMptDLK4AipdqhweCw&s"
    ],
    informacionPractica: {
      mejorEpoca: "Mayo a Octubre",
      clima: "Tropical húmedo",
      precioEntrada: "Gratis",
      comoLlegar: "Desde Rurrenabaque"
    },
    destacado: true
  },
  {
    id: 17,
    nombre: "La Paz",
    descripcion: "La capital administrativa más alta del mundo, con una mezcla única de tradición andina y modernidad.",
    region: "Altiplano",
    coordenadas: [-16.4897, -68.1193],
    imagenes: [
      "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=800",
      "https://cdn.bolivia.com/sdi/2022/12/21/la-paz-bolivia-ciudad-maravilla-1100247-1.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Abril a Octubre",
      clima: "Frío y seco",
      precioEntrada: "Gratis",
      comoLlegar: "Aeropuerto Internacional El Alto"
    },
    destacado: true
  },
  {
    id: 18,
    nombre: "Cochabamba",
    descripcion: "La ciudad de los valles, conocida por su gastronomía y el Cristo de la Concordia.",
    region: "Valles",
    coordenadas: [-17.3895, -66.1568],
    imagenes: [
      "https://cdn.bolivia.com/sdi/2022/10/13/cochabamba-bolivia-ciudad-eterna-primavera-1074687-1.jpg",
      "https://www.boliviaentusmanos.com/turismo/cochabamba/imagenes/cochabamba-centro.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Todo el año",
      clima: "Templado",
      precioEntrada: "Gratis",
      comoLlegar: "Aeropuerto Internacional Jorge Wilstermann"
    },
    destacado: true
  },
  {
    id: 19,
    nombre: "Oruro",
    descripcion: "Ciudad minera famosa por su Carnaval, declarado Patrimonio de la Humanidad.",
    region: "Altiplano",
    coordenadas: [-17.9754, -67.1105],
    imagenes: [
      "https://www.boliviaentusmanos.com/turismo/oruro/imagenes/oruro-carnaval.jpg",
      "https://cdn.bolivia.com/sdi/2022/10/13/oruro-bolivia-capital-folklore-1074687-1.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Febrero (Carnaval)",
      clima: "Frío y seco",
      precioEntrada: "Gratis",
      comoLlegar: "Bus desde La Paz o avión"
    },
    destacado: true
  },
  {
    id: 20,
    nombre: "Parque Nacional Torotoro",
    descripcion: "Parque nacional con cavernas, huellas de dinosaurios y paisajes únicos.",
    region: "Valles",
    coordenadas: [-18.1333, -65.7667],
    imagenes: [
      "https://cdn.bolivia.com/sdi/2022/10/13/torotoro-bolivia-parque-nacional-1074687-1.jpg",
      "https://www.boliviaentusmanos.com/turismo/torotoro/imagenes/torotoro-cavernas.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Mayo a Octubre",
      clima: "Templado",
      precioEntrada: "50 Bs",
      comoLlegar: "Desde Cochabamba en bus (4 horas)"
    },
    destacado: true
  },
  {
    id: 21,
    nombre: "Valle de la Luna",
    descripcion: "Formaciones rocosas erosionadas que simulan un paisaje lunar.",
    region: "Altiplano",
    coordenadas: [-16.5167, -68.1333],
    imagenes: [
      "https://cdn.bolivia.com/sdi/2022/10/13/valle-luna-bolivia-paisaje-lunar-1074687-1.jpg",
      "https://www.boliviaentusmanos.com/turismo/valle-luna/imagenes/valle-luna-formaciones.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Abril a Octubre",
      clima: "Frío y seco",
      precioEntrada: "30 Bs",
      comoLlegar: "Desde La Paz en taxi o tour"
    },
    destacado: false
  },
  {
    id: 22,
    nombre: "Chacaltaya",
    descripcion: "Antigua estación de esquí, la más alta del mundo, con vistas espectaculares.",
    region: "Altiplano",
    coordenadas: [-16.3500, -68.1333],
    imagenes: [
      "https://cdn.bolivia.com/sdi/2022/10/13/chacaltaya-bolivia-estacion-esqui-1074687-1.jpg",
      "https://www.boliviaentusmanos.com/turismo/chacaltaya/imagenes/chacaltaya-vistas.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Mayo a Agosto",
      clima: "Muy frío",
      precioEntrada: "Gratis",
      comoLlegar: "Desde La Paz en tour organizado"
    },
    destacado: false
  },
  {
    id: 23,
    nombre: "Copacabana",
    descripcion: "Pueblo turístico a orillas del Lago Titicaca, famoso por sus fiestas y peregrinaciones.",
    region: "Altiplano",
    coordenadas: [-16.1667, -69.0833],
    imagenes: [
      "https://cdn.bolivia.com/sdi/2022/10/13/copacabana-bolivia-lago-titicaca-1074687-1.jpg",
      "https://www.boliviaentusmanos.com/turismo/copacabana/imagenes/copacabana-playa.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Abril a Octubre",
      clima: "Frío y seco",
      precioEntrada: "Gratis",
      comoLlegar: "Bus desde La Paz (3 horas)"
    },
    destacado: true
  },
  {
    id: 24,
    nombre: "Parque Nacional Sajama",
    descripcion: "Parque nacional con el nevado Sajama y termas naturales.",
    region: "Altiplano",
    coordenadas: [-18.1000, -68.9000],
    imagenes: [
      "https://cdn.bolivia.com/sdi/2022/10/13/sajama-bolivia-parque-nacional-1074687-1.jpg",
      "https://www.boliviaentusmanos.com/turismo/sajama/imagenes/sajama-nevado.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Mayo a Septiembre",
      clima: "Frío y seco",
      precioEntrada: "Gratis",
      comoLlegar: "Desde Oruro en bus"
    },
    destacado: false
  },
  {
    id: 25,
    nombre: "Villa Tunari",
    descripcion: "Pueblo turístico en el Chapare, conocido por sus cascadas y naturaleza.",
    region: "Yungas",
    coordenadas: [-16.9667, -65.4167],
    imagenes: [
      "https://cdn.bolivia.com/sdi/2022/10/13/villa-tunari-bolivia-chapare-1074687-1.jpg",
      "https://www.boliviaentusmanos.com/turismo/villa-tunari/imagenes/villa-tunari-cascadas.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Mayo a Octubre",
      clima: "Tropical húmedo",
      precioEntrada: "Gratis",
      comoLlegar: "Bus desde Cochabamba"
    },
    destacado: false
  },
  {
    id: 26,
    nombre: "Buena Vista",
    descripcion: "Pueblo en los valles, conocido por sus paisajes y producción de vino.",
    region: "Valles",
    coordenadas: [-17.4500, -63.6667],
    imagenes: [
      "https://cdn.bolivia.com/sdi/2022/10/13/buena-vista-bolivia-valles-1074687-1.jpg",
      "https://www.boliviaentusmanos.com/turismo/buena-vista/imagenes/buena-vista-viñedos.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Todo el año",
      clima: "Templado",
      precioEntrada: "Gratis",
      comoLlegar: "Bus desde Santa Cruz"
    },
    destacado: false
  },
  {
    id: 27,
    nombre: "San Ignacio de Velasco",
    descripcion: "Pueblo histórico con misiones jesuíticas y arquitectura colonial.",
    region: "Llanos",
    coordenadas: [-16.3667, -60.9500],
    imagenes: [
      "https://cdn.bolivia.com/sdi/2022/10/13/san-ignacio-velasco-bolivia-misiones-1074687-1.jpg",
      "https://www.boliviaentusmanos.com/turismo/san-ignacio/imagenes/san-ignacio-iglesia.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Mayo a Octubre",
      clima: "Semi-tropical",
      precioEntrada: "Gratis",
      comoLlegar: "Bus desde Santa Cruz"
    },
    destacado: false
  },
  {
    id: 28,
    nombre: "Concepción",
    descripcion: "Pueblo histórico con misiones jesuíticas restauradas.",
    region: "Llanos",
    coordenadas: [-16.1333, -62.0333],
    imagenes: [
      "https://cdn.bolivia.com/sdi/2022/10/13/concepcion-bolivia-misiones-1074687-1.jpg",
      "https://www.boliviaentusmanos.com/turismo/concepcion/imagenes/concepcion-iglesia.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Mayo a Octubre",
      clima: "Semi-tropical",
      precioEntrada: "Gratis",
      comoLlegar: "Bus desde Santa Cruz"
    },
    destacado: false
  },
  {
    id: 29,
    nombre: "Parque Nacional Noel Kempff Mercado",
    descripcion: "Parque nacional en la Amazonía con cascadas y biodiversidad única.",
    region: "Amazonía",
    coordenadas: [-14.2667, -60.8833],
    imagenes: [
      "https://cdn.bolivia.com/sdi/2022/10/13/noel-kempff-bolivia-parque-nacional-1074687-1.jpg",
      "https://www.boliviaentusmanos.com/turismo/noel-kempff/imagenes/noel-kempff-cascadas.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Mayo a Septiembre",
      clima: "Tropical húmedo",
      precioEntrada: "Gratis",
      comoLlegar: "Avión desde Santa Cruz"
    },
    destacado: true
  },
  {
    id: 30,
    nombre: "Cobija",
    descripcion: "Capital del departamento de Pando, en la frontera con Brasil.",
    region: "Amazonía",
    coordenadas: [-11.0333, -68.7333],
    imagenes: [
      "https://cdn.bolivia.com/sdi/2022/10/13/cobija-bolivia-pando-1074687-1.jpg",
      "https://www.boliviaentusmanos.com/turismo/cobija/imagenes/cobija-centro.jpg"
    ],
    informacionPractica: {
      mejorEpoca: "Mayo a Octubre",
      clima: "Tropical húmedo",
      precioEntrada: "Gratis",
      comoLlegar: "Avión desde La Paz"
    },
    destacado: false
  }
]
